import { OpcoThemeIdentifierType } from "../themes/themeMapper";

enum OpcoSupportNumberType {
  AMFAM_SUPPORT_NUMBER = "1-800-692-6326",
  MSA_SUPPORT_NUMBER = "1-877-425-2467",
  CAH_SUPPORT_NUMBER = "1-800-872-5246",
  POLARIS_SUPPORT_NUMBER = "1-800-872-5246",
  OSI_SUPPORT_NUMBER = "1-888-495-4674",
}

export function getPhoneNumberForOpco(activeThemeIdentifier: string) {
  let supportPhoneNumber = "";
  switch (activeThemeIdentifier) {
    case OpcoThemeIdentifierType.AMFAM_IDENTIFIER:
      supportPhoneNumber = OpcoSupportNumberType.AMFAM_SUPPORT_NUMBER;
      break;
    case OpcoThemeIdentifierType.MSA_IDENTIFIER:
      supportPhoneNumber = OpcoSupportNumberType.MSA_SUPPORT_NUMBER;
      break;
    case OpcoThemeIdentifierType.CAH_IDENTIFIER:
      supportPhoneNumber = OpcoSupportNumberType.CAH_SUPPORT_NUMBER;
      break;
    case OpcoThemeIdentifierType.POLARIS_IDENTIFIER:
      supportPhoneNumber = OpcoSupportNumberType.POLARIS_SUPPORT_NUMBER;
      break;
    case OpcoThemeIdentifierType.OSI_IDENTIFIER:
      supportPhoneNumber = OpcoSupportNumberType.OSI_SUPPORT_NUMBER;
      break;
    default:
      supportPhoneNumber = OpcoSupportNumberType.AMFAM_SUPPORT_NUMBER;
      break;
  }
  return supportPhoneNumber;
}

export function getPrettyPhoneNumber(
  unformattedPhoneNumber: string | null,
  nobrackets?: boolean
): string {
  let formattedPhoneNumber = "";
  if (!unformattedPhoneNumber) {
    return formattedPhoneNumber;
  }
  if (unformattedPhoneNumber) {
    let numbersOnly = unformattedPhoneNumber.replace(/[^0-9]/g, "");
    // Check for international code in the number. If present, remove it.
    if (numbersOnly && numbersOnly.length === 11) {
      numbersOnly = numbersOnly.substring(1, 11);
    }
    if (numbersOnly && numbersOnly.length === 10) {
      const areaCode = numbersOnly.substring(0, 3);
      const prefix = numbersOnly.substring(3, 6);
      const lineNumber = numbersOnly.substring(6, 10);
      if (nobrackets) {
        formattedPhoneNumber = areaCode + "-" + prefix + "-" + lineNumber;
        return formattedPhoneNumber;
      }
      formattedPhoneNumber = "(" + areaCode + ") " + prefix + "-" + lineNumber;
      return formattedPhoneNumber;
    }
  }
  return formattedPhoneNumber;
}
